/** @graphql cc **/
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const AudioContentFragment: GraphQLTaggedNode = graphql`
	fragment AudioContentFragment_content on Content {
		id
		title
		subType
		emoji: properties(key: "emoji-title-published") {
			nodes {
				id
				value
			}
		}
		history {
			createdBy {
				displayName
				profilePicture {
					path
				}
			}
			ownedBy {
				displayName
				profilePicture {
					path
				}
			}
		}
		links {
			webui
			base
		}
		audioProperties: properties(keys: ["emoji-title-published", "editor"]) {
			nodes {
				value
				key
			}
		}
	}
`;
